import { formatDate, formatTime, shortenTimezone } from "@gigpro/utils/datetime";
import type { AdminGigApplication } from "@sidegigllc/api/client";

type ApplicationSummaryProps = {
  application: AdminGigApplication;
};

export function ApplicationSummary({ application }: Readonly<ApplicationSummaryProps>) {
  const timezone = shortenTimezone(application.timezone);
  return (
    <p>
      <b>Working Hours:</b>{" "}
      {application.working_hours?.start_time && application.working_hours.end_time ? (
        <>
          {formatDate(application.working_hours.start_time, "EEE, MMM d")},{" "}
          {formatTime(application.working_hours.start_time)} - {formatTime(application.working_hours.end_time)} (
          {timezone})
        </>
      ) : (
        "N/A"
      )}
    </p>
  );
}
